export default "__VITE_ASSET__JIVX0G9D__"